import * as React from 'react';

interface IOptionProps {
  customer: GQL.ICustomer;
}

class Option extends React.Component<IOptionProps> {
  public render() {
    const { customer } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <div>
            <b>{customer.invoiceFirstName} {customer.invoiceLastName}</b>
          </div>
          <div>{customer.email}</div>
          <div><small>{customer.invoiceCity}, {customer.invoiceCountry}</small></div>
        </div>
      </div>
    );
  }
}

export default Option;


// WEBPACK FOOTER //
// ./src/components/Others/CustomerSelect/components/Option/Option.tsx